// Dane strukturalne (spec sekcja 12).
//
// Jeden wezel firmy o staym @id "#business" - reszta grafu (Person, Service)
// odwoluje sie do niego przez referencje, zamiast powielac adres i telefon.
// Wszystkie wartosci pochodza z src/data/firma.js, wiec nie moga sie rozjechac.

import { FIRMA, SITE_URL, MAPS_LINK, CENNIK } from './firma';

export const BUSINESS_ID = `${SITE_URL}/#business`;
export const PERSON_ID = `${SITE_URL}/o-mnie/#anna-serwinska`;

const postalAddress = {
  '@type': 'PostalAddress',
  streetAddress: FIRMA.ulica,
  postalCode: FIRMA.kod,
  addressLocality: FIRMA.miasto,
  addressRegion: FIRMA.wojewodztwo,
  addressCountry: FIRMA.kraj,
};

export const BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': BUSINESS_ID,
  name: FIRMA.nazwa,
  url: `${SITE_URL}/`,
  telephone: FIRMA.telefonE164,
  email: FIRMA.email,
  image: `${SITE_URL}/sensorini-logo.png`,
  description:
    'Diagnoza i terapia integracji sensorycznej dzieci w Olsztynie. Gabinet Sensorini, ul. Partyzantów 31/5.',
  address: postalAddress,
  geo: { '@type': 'GeoCoordinates', latitude: FIRMA.lat, longitude: FIRMA.lng },
  areaServed: { '@type': 'City', name: FIRMA.miasto },
  hasMap: MAPS_LINK,
  openingHoursSpecification: FIRMA.godziny.map((g) => ({
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: g.dni,
    opens: g.od,
    closes: g.do,
  })),
  founder: { '@id': PERSON_ID },
};

export const PERSON_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  '@id': PERSON_ID,
  name: FIRMA.osoba,
  url: `${SITE_URL}/o-mnie/`,
  image: `${SITE_URL}/image/anna-sensorini-olsztyn-terapia-dla-dziecka-Anna.webp`,
  worksFor: { '@id': BUSINESS_ID },
  jobTitle: FIRMA.rola,
  knowsAbout: [
    'integracja sensoryczna',
    'diagnoza integracji sensorycznej',
    'terapia ręki',
    'trening umiejętności społecznych',
  ],
};

/** Oferta trafia do schema tylko wtedy, gdy w cenniku jest realna kwota. */
const offer = (poz, url) =>
  typeof poz.cena === 'number'
    ? {
        '@type': 'Offer',
        url,
        price: String(poz.cena),
        priceCurrency: 'PLN',
        availability: 'https://schema.org/InStock',
      }
    : undefined;

export const serviceSchema = ({ path, name, serviceType, pozycjaCennika }) => {
  const url = `${SITE_URL}${path}`;
  const node = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': `${url}#service`,
    name,
    serviceType,
    provider: { '@id': BUSINESS_ID },
    areaServed: { '@type': 'City', name: FIRMA.miasto },
    url,
  };
  const o = pozycjaCennika && offer(pozycjaCennika, url);
  if (o) node.offers = o;
  return node;
};

export const DIAGNOZA_SERVICE = serviceSchema({
  path: '/diagnoza-sensoryczna-olsztyn/',
  name: 'Diagnoza integracji sensorycznej dziecka',
  serviceType: 'Diagnoza integracji sensorycznej',
  pozycjaCennika: CENNIK.diagnoza,
});

export const TERAPIA_SERVICE = serviceSchema({
  path: '/terapia-integracji-sensorycznej-olsztyn/',
  name: 'Terapia integracji sensorycznej dla dzieci',
  serviceType: 'Terapia integracji sensorycznej',
  pozycjaCennika: CENNIK.terapia,
});

/** Okruszki: kolejnosc musi byc identyczna z widoczna nawigacja na stronie. */
export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

/** FAQPage wolno dodac tylko dla pytan faktycznie widocznych na stronie. */
export const faqSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((it) => ({
    '@type': 'Question',
    name: it.q,
    acceptedAnswer: { '@type': 'Answer', text: it.a },
  })),
});
